export default "__VITE_ASSET__22ae621e__"